import ActiveProfile from './ActiveProfile'

export default class WorkerProfile extends ActiveProfile {
  profession: string | null
  rate: string | null
  registered: number | null
  country_id: number | string | null
  city: string | null
  dob: string | null
  bio: string | null
  avgReview: number | null
  userReviews: number | null

  constructor(data: Partial<WorkerProfile>) {
    super(data as LX.ActiveProfile)
    Object.assign(this, {
      profession: data.profession,
      rate: data.rate,
      registered: data.registered,
      country_id: data.country_id,
      city: data.city,
      dob: data.dob,
      bio: data.bio,
      avgReview: data.avgReview,
      userReviews: data.userReviews,
    })
  }

  static fromServer(data: LX.WorkerProfile) {
    return new WorkerProfile({
      profession: data?.profession || '',
      rate: data?.rate ? String(data.rate) : '0.00',
      registered: data.registered || null,
      country_id: data.country_id,
      city: data.city || '',
      dob: data?.dob || '',
      bio: data?.bio || '',
      avgReview: data.avg_reviews || 0,
      userReviews: data.reviews_count || 0,
      first_name: data.first_name,
      last_name: data.last_name,
      id: data.id || data.user_id,
    })
  }
}
